module.exports = __webpack_public_path__ + "img/feature_buy_id.0b896e60.png";